import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|transportId|ownerMemberId|creatorMemberId|memberId|createdByMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey transports — independent of Day/Activity schedule. */
export const journeyTransportApi = {
  list: (journeyId) => travelClient.get(
    travelEndpoints.journeyTransports(journeyId),
    snowflakeJson,
  ),
  get: (journeyId, transportId) => travelClient.get(
    travelEndpoints.journeyTransport(journeyId, transportId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyTransports(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, transportId, body) => travelClient.patch(
    travelEndpoints.journeyTransport(journeyId, transportId),
    body,
    snowflakeJson,
  ),
  remove: (journeyId, transportId, { confirm = true } = {}) => travelClient.delete(
    travelEndpoints.journeyTransport(journeyId, transportId),
    { params: { confirm }, ...snowflakeJson },
  ),
};
